var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWellplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.12,
    height: 12.97,
    viewBox: "0 0 21.12 12.97",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-1.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.355 2.8285-0.09994 0.49095a1.874 1.6737 0 0 0-0.48307 0.10414 4.914 4.3888 0 0 0-0.46641 0.17853 1.874 1.6737 0 0 0-0.5497 0.35705 3.5814 3.1986 0 0 0-0.40811 0.52814q-0.7246 1.1232-2.1072 3.3176l-2.9317 4.664h-1.5491l-0.94115-7.0295-4.2143 7.0295h-1.4659q-0.30816-2.5217-0.56635-4.7384t-0.39145-3.273a1.6074 1.4357 0 0 0-0.16657-0.52814 1.4159 1.2646 0 0 0-0.41644-0.34962 1.2993 1.1604 0 0 0-0.38312-0.17109 2.99 2.6705 0 0 0-0.44975-0.089264l0.12493-0.49095h5.4303l-0.13326 0.49095a7.7624 6.9328 0 0 0-0.83287 0.11158 1.7157 1.5324 0 0 0-0.42477 0.1339 0.28318 0.25291 0 0 0-0.14992 0.14877 0.83287 0.74386 0 0 0 0 0.17109v0.31242 0.38681q0.058301 0.63228 0.21655 1.9936 0.15825 1.3613 0.35814 3.1837l4.0894-6.9402h1.5575l0.94115 7.156 1.6491-2.6853q0.74959-1.2497 1.1827-2.0307 0.26652-0.47607 0.47474-0.8852a2.0905 1.8671 0 0 0 0.19989-0.52814q0-0.20828-0.38312-0.34218a4.0228 3.5929 0 0 0-1.1244-0.17853l0.14992-0.49839z",
    fill: "#1fa6ce",
    strokeWidth: 0.78711
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellplace);
export default __webpack_public_path__ + "static/media/Wellplace.c59c39bfb632bfad18fb5584d76ef983.svg";
export { ForwardRef as ReactComponent };